export default "__VITE_ASSET__y0WCMh_P__"